var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"txtValidationMessage"},[_vm._v("Your selected Delivery Address is incomplete. Please edit it in Address Book before proceeding further. "),_c('a',{staticClass:"hypIndiaBazaar",attrs:{"href":"profile#address-book"}},[_vm._v("Edit Address")])])
}]

export { render, staticRenderFns }